import { Link } from 'react-router'
import { ContentCopy } from '@mui/icons-material'
import { Divider, Grid, IconButton, Tooltip, Typography } from '@mui/material'

import { ShipToInformation } from '../../routes/accounts/components/orders-tab-panel/order-accordion-details'
import { getFormattedDateTime } from '../../utils/helpers'
import useClipboard from '../../utils/hooks/useClipboard'

import useStyles from './index.styles'
import OrderField from './order-field'
import OrderTimeline from './order-timeline'

const ReorderInfo = ({ orderDetail }: { orderDetail: IReorderDetail }) => {
  const classes = useStyles
  const { clickToCopy } = useClipboard()

  return (
    <Grid
      container={true}
      sx={{
        gap: 2,
      }}
    >
      <Grid size={2.9}>
        <OrderTimeline events={orderDetail.events} orderType="reorder" />
      </Grid>
      <Grid size="auto">
        <Divider orientation="vertical" variant="middle" />
      </Grid>
      <Grid
        container={true}
        spacing={2}
        size={3}
        sx={{
          alignContent: 'flex-start',
        }}
      >
        <Grid size={12}>
          <Grid
            container={true}
            size={12}
            sx={{
              justifyItems: 'center',
            }}
          >
            <Grid size={12}>
              <Typography variant="overline" sx={classes.summaryFieldTitle}>
                Shop URL
              </Typography>
            </Grid>
            <Grid container={true} size={12}>
              <Typography
                variant="body1"
                noWrap={true}
                sx={{
                  flex: '1',
                }}
              >
                {orderDetail.shopUrl && <Link to={orderDetail.shopUrl}>{orderDetail.shopUrl}</Link>}
                {!orderDetail.shopUrl && '-'}
              </Typography>
              {orderDetail.shopUrl && (
                <Tooltip title="Copy link to clipboard" arrow={true} placement="top">
                  <IconButton
                    onClick={(e) => {
                      e.stopPropagation()
                      clickToCopy(orderDetail.shopUrl ?? '')
                    }}
                    sx={classes.copyIconButton}
                    aria-label="Copy link to clipboard"
                  >
                    <ContentCopy color="primary" sx={classes.copyIcon} />
                  </IconButton>
                </Tooltip>
              )}
            </Grid>
          </Grid>
        </Grid>
        {orderDetail.shipToAddress && (
          <Grid size={12}>
            <ShipToInformation shipToAddress={orderDetail.shipToAddress} />
          </Grid>
        )}
      </Grid>
      <Grid
        container={true}
        spacing={2}
        size="grow"
        sx={{
          alignContent: 'flex-start',
        }}
      >
        <OrderField xs={6} label="Discount Code" value={orderDetail.discountCode || 'N/A'} />
        <OrderField xs={6} label="Created" value={getFormattedDateTime(orderDetail.createdAt)} />
        <OrderField xs={6} label="Customer Order #" value={orderDetail.customerOrderNumber || 'N/A'} />
        <OrderField xs={6} label="Expiration" value={orderDetail.expirationDate ? getFormattedDateTime(orderDetail.expirationDate) : ''} />
        <OrderField xs={6} label="Replacement Id" value={orderDetail.replacementId} />
        <OrderField xs={6} label="Associated Order #" value={orderDetail.associatedOrderNumber || 'N/A'} />
        <OrderField xs={6} label="Fulfillment Order #" value={orderDetail.fulfillmentOrderNumber || 'N/A'} />
      </Grid>
    </Grid>
  )
}

export default ReorderInfo
